import React from 'react';
import styled from 'styled-components';

import Button from '../../../../../common/ui/Button';
import CtaLink from '../../../../../common/ui/CtaLink';
import { getLatestVersion } from '../../../utils/es6Helpers';

import Price from './content/Price';

const Content = (props) => {
  const { app } = props;
  const { title, salesDescription, id } = app;

  return (
    <StyledContent>
      <CtaLink to="/partners/apps" color="var(--blue-base)" reverse>
        Back to all apps
      </CtaLink>
      <StyledTitle>{title}</StyledTitle>
      <StyledDescription>{salesDescription}</StyledDescription>
      <Price version={getLatestVersion(app)} app={app} />
      <StyledButton href={`https://admin.platform.commerce7.com/app/${id}`}>
        Install App
      </StyledButton>
    </StyledContent>
  );
};

const StyledContent = styled.div`
  flex-basis: 35%;
`;

const StyledTitle = styled.h1`
  color: var(--blue-dark);
  font-size: var(--heading-size-2xl);
  font-weight: var(--font-weight-black);
  margin: 20px 0 20px;
  line-height: 65px;
`;

const StyledDescription = styled.p`
  color: var(--black);
  font-size: var(--font-size-lg);
  line-height: 1.5;
  margin-bottom: 25px;
`;

const StyledButton = styled(Button)`
  margin-top: 45px;
`;

export default Content;
